module.exports = __webpack_public_path__ + "img/16_27.57807ef0.png";